import { FC } from 'react';

// Externals
import { useIntl } from 'react-intl';

// Material
import { Box, Button, ButtonGroup, makeStyles } from '@material-ui/core';

// Context
import { LocaleContext } from 'index';

// Styles
const useStyles = makeStyles((theme) => ({
  box: {
    position: 'absolute',
    right: 10,
    top: 60,
    display: 'block',
    zIndex: 999
  },
  [theme.breakpoints.down('xs')]: {
    box: {
      position: 'absolute',
      right: 10,
      top: 60,
      zIndex: 999
    }
  },
  button: {
    width: 40,
    height: 40,
    padding: theme.spacing(1),
    color: theme.palette.getContrastText(theme.palette.primary.main),
    backgroundColor: theme.palette.primary.main + 'DD',
    '&:hover': {
      backgroundColor: theme.palette.primary.main + 'EE',
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: theme.palette.primary.main + 'DD'
      }
    },
    minWidth: 'unset',
    minHeight: 'unset'
  }
}));

interface Props {}

const LangButton: FC<Props> = (props) => {
  const classes = useStyles();

  const intl = useIntl();

  return (
    <LocaleContext.Consumer>
      {({ locale, setLocale }) => {
        return (
          <Box className={classes.box}>
            <ButtonGroup orientation="vertical" variant="contained">
              <Button
                className={classes.button}
                onClick={() => {
                  if (locale === 'fr') {
                    setLocale('nl');
                  } else {
                    setLocale('fr');
                  }
                }}
                title={intl.formatMessage({
                  id: 'Common.Language',
                  defaultMessage: 'Langue',
                  description: 'Intitulé pour le bouton de langue'
                })}
              >
                {locale.toUpperCase()}
              </Button>
            </ButtonGroup>
          </Box>
        );
      }}
    </LocaleContext.Consumer>
  );
};

export default LangButton;
